<template>
  <v-app class="login-page">
    <main class="login-shell">
      <section class="login-hero" aria-labelledby="workspace-title">
        <div class="brand-badge"><v-icon icon="mdi-view-dashboard-outline" size="24" /> <span>{{ appName }}</span></div>
        <div class="hero-copy">
          <p class="eyebrow">Business command center</p>
          <h1 id="workspace-title">One workspace<br>for operations,<br>finance, people,<br>and production.</h1>
          <p class="hero-description">Sign in to monitor approvals, reports, attendance, inventory, and daily movement from a single secure dashboard.</p>
        </div>
        <div class="hero-highlights">
          <div><strong>Live</strong><span>Approvals</span></div>
          <div><strong>360</strong><span>Records</span></div>
          <div><strong>24/7</strong><span>Access</span></div>
        </div>
      </section>
      <section class="login-panel" aria-labelledby="signin-title">
        <div class="signin-content">
          <header class="signin-heading">
            <div class="company-mark">
              <img v-if="!logoFailed" :src="`${getFileServerUrl}uploads/images/company/logo/logo.png`" :alt="appName" @error="logoFailed = true">
              <v-icon v-else icon="mdi-view-dashboard-outline" size="36" color="#117873" :aria-label="appName" role="img" />
            </div>
            <div><p class="eyebrow">Welcome back</p><h2 id="signin-title">Sign in to {{ appName }}</h2></div>
          </header>
          <v-form @submit.prevent="submit" class="signin-form">
            <p v-if="errorMessages" class="login-error" role="alert">{{ errorMessages }}</p>
            <v-text-field
              v-model="username.value.value" :error-messages="username.errorMessage.value"
              label="Username" autocomplete="username" prepend-inner-icon="mdi-account-circle-outline"
              variant="outlined" density="comfortable" color="#117873" hide-details="auto"
            />
            <v-text-field
              v-model="password.value.value" :error-messages="password.errorMessage.value"
              label="Password" autocomplete="current-password" prepend-inner-icon="mdi-lock-outline"
              :append-inner-icon="visible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
              :type="visible ? 'text' : 'password'" @click:append-inner="visible = !visible"
              variant="outlined" density="comfortable" color="#117873" hide-details="auto"
            />
            <div class="secure-login"><v-icon icon="mdi-shield-check-outline" size="18" /> Secure login</div>
            <v-btn block class="signin-button text-none" color="#117873" height="49" variant="flat" type="submit" :loading="loading" :disabled="loading" prepend-icon="mdi-login">Sign in</v-btn>
          </v-form>
          <p class="login-credit">Developed by <a href="https://www.oneumbrellait.com/" target="_blank" rel="noopener noreferrer">One Umbrella IT Ltd.</a></p>
        </div>
      </section>
    </main>
  </v-app>
</template>
<script>
import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { useRouter } from 'vue-router'; 
import { ref } from 'vue';
import { appName } from '@/store/api.js';

export default {
  name: 'MyComponent',
  data: () => ({
    loading: false,
    visible: false,
    logoFailed: false,
    errorMessages: '',
    appName,
  }),

  setup() {
    const { handleSubmit } = useForm({
      validationSchema: yup.object({
        username: yup.string().min(3).max(30).required().trim().test('no-spaces', 'Spaces are not allowed', (value) => !/\s/.test(value)).label('Username'),
        password: yup.string()
            .required('Password is required'),
            /* .matches(
              /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d@$!%*#?&]{6,30}$/,
              'Password must contain letters and numbers (special characters optional) and be 6 to 30 characters long'
            ).trim().test('no-spaces', 'Spaces are not allowed', (value) => !/\s/.test(value)), */
      }),

    });

    const username = useField('username');
    const password = useField('password');
    const loading = ref(false);
    const errorMessages  = ref('');
    const store = useStore(); 
    const router = useRouter();
    const submit = handleSubmit((values) => {
        loading.value = true;
        store.dispatch("loginRequest", values)
            .then((response) => {
              router.push("/home/dashboard");
            })
            .catch((error) => {            
              errorMessages.value = 'Username or Password Incorrect';             
            })
            .then((always) => {
              loading.value = false;
            });

    });

    return {
      username,
      password,
      submit,
      loading,
      errorMessages
    };
  },
  methods: {
  },
  computed: {
    getMessage() {
      return this.$store.getters.getMessage;
    },
    getCurrentCompany() {
      return this.$store.getters.getCurrentCompany;
    },
    getFileServerUrl() {
      return this.$store.getters.getFileServerUrl;
    },
  },
  mounted() {
    // this.username.value.value = '';
    // this.password.value.value = '';
  }
};
</script>
<style scoped>
.login-page { background: #f8fafb; color: #102332; }
.login-shell { display: grid; grid-template-columns: 56% 44%; min-height: 100vh; min-height: 100svh; }
.login-hero { display: flex; flex-direction: column; justify-content: space-between; gap: 64px; padding: clamp(40px, 3.75vw, 80px); color: white; background: linear-gradient(115deg, rgba(7, 33, 42, .88), rgba(9, 75, 70, .82) 65%, rgba(20, 53, 48, .72)), url('@/assets/image/login-bg.jpg') center / cover; }
.brand-badge { display: inline-flex; align-items: center; gap: 12px; align-self: flex-start; padding: 12px 16px; border: 1px solid #ffffff4d; border-radius: 8px; background: #ffffff14; font-size: 16px; font-weight: 700; }
.hero-copy { max-width: 760px; }
.eyebrow { margin: 0 0 14px; color: #ff9956; font-size: 12px; line-height: 1.5; font-weight: 800; text-transform: uppercase; }
.hero-copy h1 { font-size: clamp(42px, 4.4vw, 86px); line-height: .96; letter-spacing: -1.8px; font-weight: 800; }
.hero-description { max-width: 560px; margin-top: 28px; font-size: 16px; line-height: 1.85; color: #e2eef0; }
.hero-highlights { display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; max-width: 620px; }
.hero-highlights > div { display: flex; flex-direction: column; gap: 3px; padding: 16px 18px; border: 1px solid #ffffff40; border-radius: 8px; background: #ffffff21; }
.hero-highlights strong { font-size: 24px; line-height: 1.35; }
.hero-highlights span { color: #c9dcdf; font-size: 13px; }
.login-panel { display: flex; align-items: center; justify-content: center; padding: 64px 40px; background: linear-gradient(160deg, #fff, #f3f7f8); }
.signin-content { width: 100%; max-width: 460px; }
.signin-heading { display: flex; align-items: center; gap: 18px; margin-bottom: 32px; }
.company-mark { display: flex; align-items: center; justify-content: center; flex: 0 0 76px; height: 76px; padding: 8px; border: 1px solid #d5e0e5; border-radius: 9px; background: white; box-shadow: 0 16px 40px #193e4710; }
.company-mark img { width: 100%; height: 100%; object-fit: contain; }
.signin-heading .eyebrow { margin-bottom: 10px; }
.signin-heading h2 { font-size: 30px; line-height: 1.15; font-weight: 750; letter-spacing: -.5px; }
.signin-form { display: flex; flex-direction: column; gap: 22px; }
.signin-form :deep(.v-field) { border-radius: 8px; font-size: 15px; }
.signin-form :deep(.v-field__input) { min-height: 48px; }
.secure-login { display: flex; align-items: center; justify-content: flex-end; gap: 6px; margin-top: -2px; color: #647c8c; font-size: 13px; }
.signin-button { border-radius: 8px; font-size: 16px; font-weight: 700; letter-spacing: .4px; }
.login-error { padding: 10px 12px; color: #b42318; background: #fff0ee; border-radius: 6px; font-size: 14px; }
.login-credit { margin-top: 28px; text-align: center; color: #728797; font-size: 14px; }
.login-credit a { margin-left: 4px; color: #087d83; font-weight: 600; text-decoration: none; }
.login-credit a:hover { text-decoration: underline; }
@media (min-width: 1500px) { .login-hero { padding-top: 70px; padding-bottom: 70px; } }
@media (max-width: 1050px) { .login-shell { grid-template-columns: 50% 50%; } .login-hero { padding: 36px; } .hero-copy h1 { font-size: 48px; } .login-panel { padding: 40px 28px; } .signin-heading h2 { font-size: 26px; } }
@media (max-width: 760px) { .login-shell { grid-template-columns: 1fr; } .login-hero { padding: 28px 24px; gap: 32px; } .hero-copy h1 { font-size: clamp(36px, 7.5vw, 54px); line-height: 1.04; letter-spacing: -1px; } .hero-copy h1 br { display: none; } .hero-description { margin-top: 18px; font-size: 14px; } .hero-highlights { max-width: none; } .hero-highlights > div { padding: 12px; } .login-panel { padding: 44px 24px; } .signin-heading h2 { font-size: 25px; } .company-mark { flex-basis: 64px; height: 64px; } }
</style>